function Message() {
	this.id = null;
	this.userableId = null;
	this.userableType = null;
	this.message = null;
	this.createdAt = null;
	this.read = null;
	this.wasSentByCurrentUser = null;

	this.init = function () {};
}